import consumer from "./consumer"

let channelInitialized = false;

function initializeOnlineMembersChannel() {
    if (channelInitialized) return;

    let archive_section = document.getElementById('newsletter-readers')
    if (archive_section) {
        console.log('Found newsletter-readers, creating subscription')
        channelInitialized = true;

        consumer.subscriptions.create({
            channel: "OnlineMembersChannel",
            member: archive_section.dataset.memberId
        }, {
            connected() {
                // Add connection data if needed
            },

            disconnected() {
                // Handle disconnection if needed
            },

            received(data) {
                console.log('Data received in OnlineMembersChannel:', data)
            }
        })
    }
}

// Run initialization when DOM is loaded
document.addEventListener('DOMContentLoaded', initializeOnlineMembersChannel)

// Also check if DOM is already loaded (in case script loads late)
if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initializeOnlineMembersChannel()
}

// Watch for element appearance if it might be added dynamically
if (!document.getElementById('newsletter-readers')) {
    const observer = new MutationObserver((mutations, obs) => {
        if (document.getElementById('newsletter-readers')) {
            initializeOnlineMembersChannel()
            obs.disconnect()
        }
    })

    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
}
